var map = {
	"./": 31183,
	"./default": 1558,
	"./default.ts": 1558,
	"./demo": 2396,
	"./demo.ts": 2396,
	"./dev1": 37865,
	"./dev1.ts": 37865,
	"./dev2": 4888,
	"./dev2.ts": 4888,
	"./generate": 36732,
	"./generate.ts": 36732,
	"./index": 31183,
	"./index.ts": 31183,
	"./integration": 58485,
	"./integration.ts": 58485,
	"./prod": 17406,
	"./prod.ts": 17406,
	"./stage": 3517,
	"./stage.ts": 3517,
	"./test": 171,
	"./test.ts": 171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6886;